import { Component } from '@angular/core';

@Component({
  selector: 'hfc-logout-button',
  templateUrl: './logout-button.component.html',
  styleUrls: ['./logout-button.component.scss']
})
export class LogoutButtonComponent {}
